import WordsCategories from "./WordsCategories";

export default WordsCategories;
